import { useRef } from "react";
import { useStoreState } from "ezStore";
import { DateRangePicker as CCKDateRangePicker } from "@cofano/cck";
import { DateRangePickerProps } from "@cofano/cck/DatePicker/DateRangePicker";
import { DateUtils } from "utils/DateUtils";
import useDateSegmentSelect from "components/hooks/useDateSegmentSelect";

const DateRangePicker = ({ ...rest }: DateRangePickerProps) => {

	const { user } = useStoreState(store => store.session);
	const language = DateUtils.getDatePickerLocale(user?.language);

	const inputRef = useRef<HTMLInputElement | null>(null);

	const dateFormat = () => {
		if (rest.showWeekPicker) {
			return "I/R";
		} else if (rest.showTimeSelect || rest.showTimeInput) {
			return DateUtils.getDateTimeFormat(language);
		} else {
			return DateUtils.getDateFormat(language);
		}
	};

	const currentFormat = dateFormat();

	const { selectSegmentAtCursor } = useDateSegmentSelect(
		inputRef,
		currentFormat,
		Boolean(rest.startDate),
	);

	return (
		<CCKDateRangePicker
			{...rest}
			inputRef={inputRef}
			onInputClick={selectSegmentAtCursor}
			dateFormat={dateFormat()}
			portalId={"date-picker-container" }
			popperPlacement={"bottom-start"}
			placeholderText={rest.showWeekPicker ? "" : `${currentFormat} - ${currentFormat}`}
			showWeekNumbers
			fixedHeight />
	);
};

export default DateRangePicker;
